module.exports = __webpack_public_path__ + "media/images/restaurant/index_hero_img_sp-09f596e0eb3f1804c1d3728a0775d379.jpg";